export class AutoPickAttrProcessor {
    constructor(autoOptDefaultValue, cherryPicks, ignoreAttributeFromAutoPickerCallback, isAttributeRequiredCallback) {
        this.autoOptDefaultValue = autoOptDefaultValue;
        this.cherryPicks = cherryPicks;
        this.ignoreAttributeFromAutoPickerCallback = ignoreAttributeFromAutoPickerCallback;
        this.isAttributeRequiredCallback = isAttributeRequiredCallback;
    }
    invoke(productItem, attrComputer) {
        let runAutoPick = true;
        let iteration = 0;
        while (runAutoPick) {
            iteration++;
            attrComputer.evaluate(productItem);
            runAutoPick = this.autoPickAttributes(productItem, attrComputer);
            if (iteration >= 5) {
                // TODO: Throw error to detect if this ever happens
                // Protected from endless loops
                break;
            }
        }
        runAutoPick = true;
        iteration = 0;
        while (runAutoPick) {
            iteration++;
            attrComputer.evaluate(productItem);
            runAutoPick = this.tryAutoPickFromCherries(productItem, attrComputer);
            if (iteration >= 5) {
                // TODO: Throw error to detect if this ever happens
                // Protected from endless loops
                break;
            }
        }
        return !runAutoPick && iteration == 1;
    }
    autoPickAttributes(productItem, attrComputer) {
        const valuesAsString = this.getAttributesAsString(productItem);
        for (const attributeName in attrComputer.getAttributes()) {
            if (this.ignoreAttributeFromAutoPickerCallback(attributeName)) {
                continue;
            }
            const currentValue = productItem === null || productItem === void 0 ? void 0 : productItem.getAttribute(attributeName);
            if (currentValue || this.isAttributeRequiredCallback(attributeName)) {
                const cherryPick = this.cherryPicks.getAttribute(attributeName);
                this.autoPick(productItem, attrComputer, attributeName, currentValue, cherryPick);
            }
        }
        return valuesAsString != this.getAttributesAsString(productItem);
    }
    tryAutoPickFromCherries(productItem, attrComputer) {
        const valuesAsString = this.getAttributesAsString(productItem);
        for (const attributeName in attrComputer.getAttributes()) {
            if (this.cherryPicks.hasAttribute(attributeName)) {
                const cherryPick = this.cherryPicks.getAttribute(attributeName);
                const currentValue = productItem === null || productItem === void 0 ? void 0 : productItem.getAttribute(attributeName);
                if (!currentValue || currentValue != cherryPick) {
                    this.autoPick(productItem, attrComputer, attributeName, currentValue, cherryPick);
                }
            }
        }
        return valuesAsString != this.getAttributesAsString(productItem);
    }
    autoPick(productItem, attrComputer, attributeName, currentValue, cherryPick) {
        if (attrComputer === null || attrComputer === void 0 ? void 0 : attrComputer.isMultiValue(attributeName)) {
            if (!Array.isArray(currentValue)) {
                currentValue = [currentValue];
            }
            let newValues = currentValue.filter((value) => attrComputer.isAvailable(attributeName, value));
            if (cherryPick) {
                cherryPick = cherryPick.filter((value) => attrComputer.isAvailable(attributeName, value) && newValues.indexOf(value) < 0);
                newValues = [...newValues, ...cherryPick];
            }
            this.cherryPicks.maybeRegisterALost(attributeName, newValues);
            productItem === null || productItem === void 0 ? void 0 : productItem.setAttribute(attributeName, newValues);
            console.log('Autopicking', `"${attributeName}"`, newValues);
        }
        else {
            const defaultValue = attrComputer.getDefaultValue(attributeName);
            //			let newValue     = attributeHelper.isAvailable( attributeName, currentValue ) && !this.shouldAutoOptForDefaultValue( attributeName ) ? currentValue : defaultValue;
            let newValue = (currentValue == null && !this.isAttributeRequiredCallback(attributeName)) ||
                attrComputer.isAvailable(attributeName, currentValue)
                ? currentValue
                : defaultValue;
            if (!newValue && attrComputer.isDynamicValue(attributeName) && defaultValue) {
                newValue = defaultValue;
            }
            if (cherryPick && attrComputer.isAvailable(attributeName, cherryPick) && !attrComputer.isDynamicValue(attributeName)) {
                newValue = cherryPick;
            }
            this.cherryPicks.maybeRegisterALost(attributeName, newValue);
            productItem.setAttribute(attributeName, newValue);
            console.log('Autopicking', `"${attributeName}"`, newValue);
        }
    }
    /**
     * TODO: Not sure what difference this does. Turned it off to see if we really need it.
     * Whether an attribute should try to autopick default value if no value has been cherry picked.
     *
     * @param attributeName
     */
    shouldAutoOptForDefaultValue(attributeName) {
        return this.autoOptDefaultValue.indexOf(attributeName) >= 0;
    }
    getAttributesAsString(item) {
        return Object.entries(item.getAttributes())
            .map(([key, value]) => `|${key}:${value}|`)
            .join('');
    }
}
